import { useState, useEffect } from "react"
import { useContext } from "react"
import { UserContext } from "../context/userContext"
import _ from "lodash"

export default function useLabels(templateList) {
  const userCtx = useContext(UserContext)
  const [loading, setLoading] = useState(true)

  const labelsRef = userCtx.session.labels
  const [labels, setLabels] = useState({})

  useEffect(() => {
    setLoading(true)
    const unsubscribe = labelsRef.onSnapshot(
      (docSnapshot) => {
        const labelList = docSnapshot.data()
        const reqLabels = _.reduce(
          templateList,
          (acc, template_name) => {
            const reqTemplate = _.find(labelList, { template_name })
            if (_.isEmpty(reqTemplate)) return acc
            const disabledTemplate = reqTemplate.template_availability === 0
            if (disabledTemplate) {
              return { ...acc, [template_name]: null }
            }
            return { ...acc, [template_name]: reqTemplate.template_title }
          },
          {}
        )
        setLabels(reqLabels)
        setLoading(false)
      },
      (err) => {
        console.error(`Encountered error: ${err}`)
      }
    )
    // Cleanup function
    return () => unsubscribe()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [labelsRef])

  return [loading, labels]
}
